import {createSelector} from 'reselect';
import {getIsInCombinedUXExperiment, getIsInCardChunkingExperiment} from './ExperimentSelectors';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, getIsInCardChunkingExperiment, getIsInCombinedUXExperiment],
  (settings, isInCardChunkingExperiment, isInCombinedUXExperiment) => (
    settings?.enable_card_number_chunking || isInCardChunkingExperiment || isInCombinedUXExperiment
  ),
);
